import gql from 'graphql-tag';

// Planogram item mutations
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

export { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';
export { default as TOGGLE_DEX_SELECTION } from './TOGGLE_DEX_SELECTION';
export { default as TOGGLE_DECREMENT_QUANTITY } from './TOGGLE_DECREMENT_QUANTITY';
export { default as CANCEL_QUEUED_PRICE_CHANGE } from './CANCEL_QUEUED_PRICE_CHANGE';
export { default as CANCEL_QUEUED_PRODUCT_CHANGE } from './CANCEL_QUEUED_PRODUCT_CHANGE';
export { default as CHANGE_PRODUCT_QUEUE_TYPE } from './CHANGE_PRODUCT_QUEUE_TYPE';
export { default as CHANGE_PRICE_QUEUE_TYPE } from './CHANGE_PRICE_QUEUE_TYPE';

export { default as MODIFY_PLANOGRAM_ITEMS } from './MODIFY_PLANOGRAM_ITEMS';
export { default as FORCE_QUEUED_PRICE_CHANGE } from './FORCE_QUEUED_PRICE_CHANGE';
export { default as FORCE_QUEUED_PRODUCT_CHANGE } from './FORCE_QUEUED_PRODUCT_CHANGE';
export { default as MODIFY_PLANOGRAM_ITEM_PRICE } from './MODIFY_PLANOGRAM_ITEM_PRICE';
export { default as MODIFY_PLANOGRAM_ITEM_QUANTITY } from './MODIFY_PLANOGRAM_ITEM_QUANTITY';
export { default as MODIFY_PLANOGRAM_ITEM_PARLEVEL } from './MODIFY_PLANOGRAM_ITEM_PARLEVEL';
export { default as MODIFY_PLANOGRAM_ITEM_CAPACITY } from './MODIFY_PLANOGRAM_ITEM_CAPACITY';
export { default as MODIFY_PLANOGRAM_ITEM_PRODUCT } from './MODIFY_PLANOGRAM_ITEM_PRODUCT';
export { default as QUEUE_PLANOGRAM_ITEM_PRODUCT_CHANGES } from './QUEUE_PLANOGRAM_ITEM_PRODUCT_CHANGES';
export { DESTROY_PLANOGRAM_ITEM } from './DESTROY_PLANOGRAM_ITEM';
export { CREATE_PLANOGRAM_ITEM } from './CREATE_PLANOGRAM_ITEM';
export { CREATE_PLANOGRAM_ROW } from './CREATE_PLANOGRAM_ROW';
export { SWAP_PLANOGRAM_ITEMS } from './SWAP_PLANOGRAM_ITEMS';

export const MODIFY_PLANOGRAM_ITEM_SELECTION = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			id
			selection
		}
	}
`;

export const MODIFY_PLANOGRAM_ITEM_EXPIRY_DATES = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			id
			expiryDates
		}
	}
`;

export const MODIFY_PLANOGRAM_ITEM_PARLEVEL_UNLOCKED = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			id
			parlevelUnlocked
			ignoreProductDynamicParlevelsOverride
		}
	}
`;

export const MOVE_PLANOGRAM_ITEM = gql`
	mutation movePlanogramItem(
		$id: ID,
		$row: Int,
		$column: Int,
		$planogramItemGroupId: ID,
	) {
		movePlanogramItem (
			id: $id,
			row: $row,
			column: $column,
			planogramItemGroupId: $planogramItemGroupId,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;
